<template>
  <div class="orderCenter clearfix">
    <div class="titleBox">
      <h2 class="m-0">
        <small class="ml-3">
          <router-link tag='small' to="/home/cashback">
            <b class="content cursor">我的返现</b>
          </router-link>
        </small>
        <span class="ml-3">使用记录</span>
        <button @click='toBack' class="btn btn-outline-dark btn-round d-block d-lg-none">商城 <i class="iconfont icon-qianwang"></i></button>
      </h2>
      <hr>
      <p class="content">所有的订单都在这里，如有疑问请联系客服！</p>
    </div>
    <div class="searchBox">
      <div class="box riqi">
        <div class="form-group m-0">
          <label>日期选择</label>
          <div class="zujian">
            <date-range-picker
              ref="picker"
              :opens="opens"
              :locale-data="localeData"
              :minDate="minDate" :maxDate="maxDate"
              :singleDatePicker="singleDatePicker"
              :timePicker="timePicker"
              :timePicker24Hour="timePicker24Hour"
              :showWeekNumbers="showWeekNumbers"
              :showDropdowns="showDropdowns"
              :autoApply="autoApply"
              v-model="dateRange"
              @update="updateValues"
              @toggle="logEvent('event: open', $event)"
              @start-selection="logEvent('event: startSelection', $event)"
              @finish-selection="logEvent('event: finishSelection', $event)"
              :linkedCalendars="linkedCalendars"
            >
            </date-range-picker>
            <i @click="clearDateTangeFun" class="iconfont icon-guanbi clear"></i>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="form-group m-0">
          <label>订单号</label>
          <input @input="initData(true)" v-model="no" type="text" class="form-control">
        </div>
      </div>
    </div>
    <div class="jiazaiBox" v-if="intLoading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="orderBox" v-if="!intLoading && data.length!==0">
      <div v-if="!is_loading && data.length!==0" v-for="(app,index) in data" :key="index" class="lis">
        <div class="infoBox">
          <div class="">
            <b>日期：{{app.addtime}}</b>
          </div>
        </div>
        <div class="showBox">
          <div>
            <span class="content">使用订单：</span>{{app.orderNo}}
          </div>
          <div>
            <span class="content">使用数额：</span>- {{app.currencyType==='1'?'￥':''}}{{app.currencyType==='2'?'$':''}}{{app.price}}
          </div>
        </div>
      </div>
      <div v-if="!is_loading && data.length!==0" class="description text-center">
        <br>
        <br>
        <div v-if='isLoading && page!==1' class='dynamicMessage'>
          <i class='iconfont icon-jiazai xuanzhuan' style="font-size: 28px;"></i>
        </div>
        <div v-if='isNodata' class='dynamicMessage'>
          — 没有更多了 —
        </div>
        <div v-if='isError' class='dynamicMessage'>
          — 请求失败 —
        </div>
        <br>
        <br>
        <br>
      </div>
    </div>
    <div><br><br><br><br><br><br><br><br><br><br><br><br><br></div>
  </div>
</template>

<script>
  import generalMix from '@/util/mix/general';
  import resultCommons from '@/util/resultcommons';
  import commons from '@/util/commons';
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

  export default {
    name: 'orderCenter',
    mixins: [generalMix],
    data () {
      return {
        ossImgDomain: process.env.OSS_IMG_DOMAIN,
        // 筛选
        no: '',
        // 时间筛选
        opens: 'right',
        minDate: null, // 最小时间
        maxDate: null, // 最大时间
        singleDatePicker: false, // 范围为false
        timePicker: false, // 是否选择小时和分钟
        timePicker24Hour: true, // 24小时制
        showWeekNumbers: true, // 左侧显示周数
        showDropdowns: true, // 显示下拉选择 快速选择年份和月份
        autoApply: true, // 第二次点击自动选择
        dateRange: {
          startDate: null,
          endDate: null
        }, // 时间值
        linkedCalendars: true, // 每个日历都有单独的导航
        localeData: {
          firstDay: 1,
          format: 'yyyy-mm-dd',
          separator: ' 至 ',
          applyLabel: '确定',
          cancelLabel: '取消',
          daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
          monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        // 分页
        data: [], // 数据队列
        allPage: 1, // 总页数
        allNumber: 0,
        page: 1, // 当前页数
        is_empty: false, // 是否为空数据(没有任何数据)
        isNodata: false, // 没有更多了
        isLoading: false, // 是否请求中
        isError: false, // 请求失败
        intLoading: true, // 初始化加载
        anliArr:[],
        is_loading:false
      }
    },
    computed:{
      whereObj() {
        return {
          page: this.page,
          no: this.no,
          startTime: commons.getData(this.dateRange.startDate),
          endTime: commons.getData(this.dateRange.endDate)
        };
      }
    },
    components: {
      DateRangePicker
    },
    methods:{
      clearDateTangeFun() {
        if(this.dateRange.startDate || this.dateRange.endDate){
          this.dateRange = {startDate: null, endDate: null};
          this.initData();
        }
      },
      // 更新了日期
      updateValues() {
        this.initData();
      },
      logEvent(message, event) {
      },
      // 状态切换
      loadingFun(bool) {
        if (bool === 1) {
          // 加载中
          this.isNodata = false;
          this.isError = false;
          this.isLoading = true;
        } else if (bool === 2) {
          // 关闭所有
          this.isNodata = false;
          this.isError = false;
          this.isLoading = false;
        } else if (bool === 3) {
          // 没有更多了
          this.isNodata = true;
          this.isError = false;
          this.isLoading = false;
        } else {
          // 请求失败了
          this.isNodata = false;
          this.isError = true;
          this.isLoading = false;
        }
      },
      scroll(that, node) {
        node.onscroll = () => {
          // 距离底部200px时加载一次
          const bottomOfWindow = commons.scrollToButton() <= 150;
          // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
          if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
            const whereJson = that.whereObj;
            resultCommons.apiCrmdatacashbackloglists(that, whereJson).then((ob) => {
              console.log(ob, this.page);
            });
          }
        };
      },
      initData() {
        this.intLoading = true;
        // 执行搜索
        this.loadingFun(2);
        // 初始化
        this.data = [];
        this.allPage = 1;
        this.page = 1;
        // 不为空
        this.is_empty = false;
        const whereJson = this.whereObj;
        // 执行搜索
        resultCommons.apiCrmdatacashbackloglists(this, whereJson).then((ob) => {}).then(app=>{
          this.intLoading = false;
        });
      }
    },
    created() {
    },
    mounted() {
      this.initData(true);
      this.scroll(this, window);
      $('html').removeClass('scrollHide');
    },
    beforeDestroy() {
      // 清除事件
      window.onscroll = null;
    },
    destroyed() {
    }
  }
</script>

<style scoped lang='less'>

  .orderCenter {
    div.orderBox{
      background: #FFFFFF;
      border-radius: 5px;
      overflow: hidden;
      min-height: 90vh;
      div.lis{
        padding:20px 20px;
        /*border-top: 1px solid #E5E5E5;*/
        border-bottom: 1px solid #E5E5E5;
        div.infoBox{
          display: flex;
          margin-bottom: 15px;
          div{
            /*line-height: 40px;*/
            &:first-child{
              flex: 1;
              font-size: 18px;
              font-weight: bold;
            }
            &:last-child{
              font-size: 18px;
            }
          }
        }
        div.showBox{
          display: flex;
          margin-bottom: 10px;
          div{
            flex: 1;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        div.detailBox{
          ul{
            li{
              font-size: 13px;
              i{
                font-size: 13px;
              }
            }
          }
        }
      }
    }
    .titleBox {
      margin-top: 30px;
      margin-bottom: 30px;
      p {
        margin: 0;
      }
    }
    div.searchBox{
      margin-bottom: 20px;
      display: flex;
      div.box{
        flex: 1;
        margin-right: 15px;
        div.form-group{
          height: 59px;
        }
        &:last-child{
          margin: 0;
        }
        &.riqi{
          flex: auto;
          width: 70px;
          div.zujian{
            position: relative;
            .vue-daterange-picker{
              width: 100%;
            }
            i.clear{
              position: absolute;
              right: 5px;
              top: 8px;
              color: rgba(0,0,0,0.4);
              cursor: pointer;
              &:hover{
                color: rgba(0,0,0,1);
              }
            }
          }
        }
      }
    }
    div.jiazaiBox{
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      min-height: 250px;
      .spinner-border{
        width: 3rem;
        height: 3rem;
        color: red;
      }
    }
    div.emptyBox{
      background: #FFFFFF;
      min-height: 90vh;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size:86px;
      }
    }
    @media (max-width: 992px) {
      .titleBox {
        margin-top: 0;
        h2{
          display: flex;
          justify-content: space-between;
        }
        p {
          margin: 0;
          color: #9B9B9B;
        }
      }
    }
    @media (max-width: 767px) {
      .titleBox {
        text-align: center;
        p{
          padding: 0 15px;
        }
      }
      div.searchBox{
        flex-direction: column;
        div.box{
          width: 100%;
          margin-right: 0;
          margin-bottom: 10px;
          &.riqi{
            width: 100%;
            margin-bottom: 10px;
          }
        }
      }
      div.orderBox{
        div.lis{
          padding:20px 20px;
          border-bottom: 1px solid #E5E5E5;
          div.showBox{
            display: block;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/cashback/Use.vue